import React from 'react';
import Header from './components/Header';
import AboutMe from './components/AboutMe';
import Projects from './components/Projects';
import ContactDetails from './components/ContactDetails';
import Footer from './components/Footer';
import './style.css';

function App() {
  return (
    <div className="App">
      <Header />
      <AboutMe />
      <Projects />
      <ContactDetails />
      <Footer />
    </div>
  );
}

export default App;
